import React from 'react';
import Translate from '../../../../../../src/components/Translate/Translate';
import CustomSelect from '../../../../../../src/components/Fields/CustomSelect';
import {FormFieldConfigSize} from '../../../../../../src/@types/components/Form';
import classnames from '../../../../../../src/helpers/classnames';
import trans from '../../../../../../src/helpers/trans';
import {Controller, useFormContext} from 'react-hook-form';
import FormErrorMessage from '../../../../../../src/components/Form/FormErrorMessage';
import {TaskRepresentationProps} from '../VoidTask';

const targetOptions = ['order', 'order-product'].map(key => ({
    value: key,
    label: `TaskForm.change-status.targets.${key}`,
}));

export default function TargetField({formId, task, isDisabled}: {
    formId: string,
    task: TaskRepresentationProps<any>['task'],
    isDisabled?: boolean,
}) {
    isDisabled ??= Boolean(task.id);
    const {control} = useFormContext();

    return <Controller
            name="payload.target"
            control={control}
            render={(
                    {
                        field: {name, value, onChange, onBlur},
                        fieldState: {error}
                    }
            ) => {
                return <>
                    <Translate<HTMLLabelElement>
                            message="TaskForm.change-status.fields.target"
                            tag="label"
                            className="col-form-label-sm col-form-label"
                    />

                    <CustomSelect
                            label="TaskForm.change-status.fields.target"
                            size={FormFieldConfigSize.SM}
                            className={classnames({'is-invalid': error})}
                            isInvalid={Boolean(error)}
                            name={name}
                            value={value}
                            disabled={isDisabled}
                            options={targetOptions.map(option => {
                                option.label = trans(option.label);

                                return option;
                            })}
                            onChange={onChange}
                            onBlur={onBlur}
                            formId={formId}
                            menuPortalTarget={document.body}
                    />

                    <FormErrorMessage fieldName="payload.target"/>
                </>;
            }}
    />;
}
